/**
 * Implement a function that draws dots with the given spacing
 * for the given scene.
 */
export function addSceneBackgroundDots({
  sceneHeight,
  sceneWidth,
  spacing,
}: {
  sceneHeight: number;
  sceneWidth: number;
  spacing: number;
}) {
  // the extra offset logic helps show the map 2 "spacings" away from
  // the actual scene walls
  for (let y = -spacing * 2; y <= sceneHeight + spacing * 3; y += spacing) {
    for (let x = -spacing * 2; x <= sceneWidth + spacing * 3; x += spacing) {
      add([pos(x, y), color(150, 150, 150), circle(1)]);
    }
  }
}
